import { createRoute, Outlet } from "@tanstack/react-router";
import { MyNoticesPage } from "pages/app/MyNoticesPage";
import { NoticeDetailsContainer } from "pages/app/NoticeDetailsPage";
import { NoticeListsPage } from "pages/app/NoticeListsPage";
import { NoticesAnalysisPage } from "pages/app/NoticesAnalysisPage";
import { NoticesV2Page } from "pages/app/NoticesV2Page";

import { rootRoute } from "../rootRoute";

// ---------------------------------------------------------------------------
// /notices layout — groups NoticeListsPage, lists, and analysis under one prefix
// ---------------------------------------------------------------------------

const noticesLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/notices",
  staticData: { pageName: "" },
  component: Outlet,
});

const noticesIndexRoute = createRoute({
  getParentRoute: () => noticesLayoutRoute,
  path: "/",
  staticData: { pageName: "Notices" },
  component: NoticeListsPage,
});

const noticesListsRoute = createRoute({
  getParentRoute: () => noticesLayoutRoute,
  path: "/lists",
  staticData: { pageName: "Saved notices page" },
  component: MyNoticesPage,
});

const noticesAnalysisRoute = createRoute({
  getParentRoute: () => noticesLayoutRoute,
  path: "/analysis",
  staticData: { pageName: "Notice View Analysis" },
  component: NoticesAnalysisPage,
});

// ---------------------------------------------------------------------------
// /noticesv2 — standalone route for topic search beta
// ---------------------------------------------------------------------------

export const noticesV2Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/noticesv2",
  staticData: { pageName: "NoticesV2Page" },
  component: NoticesV2Page,
});

// ---------------------------------------------------------------------------
// /notices/$guid — notice detail pages with nested sub-routes
// ---------------------------------------------------------------------------

const noticeDetailLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/notices/$guid",
  staticData: { pageName: "" },
  component: Outlet,
});

const noticeDetailRoute = createRoute({
  getParentRoute: () => noticeDetailLayoutRoute,
  path: "/",
  // pageName deliberately empty so the router-level `tracking.pageView` subscriber skips it —
  // NoticeDetailsContainer emits its own "Notice Details" page view once the notice loads, with
  // the Stage/Signal props Amplitude needs to segment award vs tender usage.
  staticData: { pageName: "" },
  component: function NoticeDetailRouteComp() {
    const { guid } = noticeDetailRoute.useParams();
    return <NoticeDetailsContainer noticeGuid={guid} />;
  },
});

const noticeDetailCatchAllRoute = createRoute({
  getParentRoute: () => noticeDetailLayoutRoute,
  path: "/$",
  // pageName deliberately empty — see noticeDetailRoute above; NoticeDetailsContainer emits.
  staticData: { pageName: "" },
  component: function NoticeDetailCatchAllRouteComp() {
    const { guid } = noticeDetailCatchAllRoute.useParams();
    return <NoticeDetailsContainer noticeGuid={guid} />;
  },
});

// ---------------------------------------------------------------------------
// Route trees — export for registration in routes.tsx
// ---------------------------------------------------------------------------

export const noticesRouteTree = noticesLayoutRoute.addChildren([
  noticesIndexRoute,
  noticesListsRoute,
  noticesAnalysisRoute,
]);

export const noticeDetailRouteTree = noticeDetailLayoutRoute.addChildren([
  noticeDetailRoute,
  noticeDetailCatchAllRoute,
]);
